<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MggEod/tc-custom/9781488001215.jpg?1725038584944" alt="This image is the cover for the book Demetriou Demands His Child, Secret Heirs of Billionaires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Demetriou Demands His Child, Secret Heirs of Billionaires
      </h1>
      <p class="bookDescription body article font2">
        <b>A Greek billionaire’s love child could end a family feud in this contemporary romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Ten years ago, innocent Iolanthe Petrakis surrendered to the most ruthless tycoon in Athens. Alekos Demetriou gave her the one and only sinfully seductive night of her life. But when he discovered she was the daughter of his enemy, he cast her out . . . before Iolanthe could reveal she was pregnant with his child!<br/><br/>Now, with her family’s company in peril, Iolanthe’s forced to reveal her most precious secret to her nemesis. When he learns the truth, Alekos declares he will legitimize his son and, to Iolanthe’s horror, informs her they will marry!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Hewitt
      </h2>
      
      <p class="authorDescription body article">Kate Hewitt has worked a variety of different jobs, from drama teacher to editorial assistant to youth worker, but writing romance is the best one yet. She also writes women&#39;s fiction and all her stories celebrate the healing and redemptive power of love. Kate lives in a tiny village in the English Cotswolds with her husband, five children, and an overly affectionate Golden Retriever.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b3bc07d